import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'
import { IncomingMessage, ServerResponse } from 'http'

import { STUDENTS_BENEFIT_ALERT_DISMISSED } from '../constants'

const getStudentsBenefitAlertViewKey = (pid = 'user') => {
  return `${pid}-${STUDENTS_BENEFIT_ALERT_DISMISSED}`
}

const setStudentsBenefitAlertView = (pid = 'user', response: ServerResponse | null = null) => {
  setJusbrasilCookie(response, getStudentsBenefitAlertViewKey(pid), Date.now())
}

const getStudentsBenefitAlertView = (pid = 'user', request: IncomingMessage | null = null) => {
  return getCookie(request, getStudentsBenefitAlertViewKey(pid))
}

export const studentsBenefitPersistentAlertBannerPersisted = {
  getKey: getStudentsBenefitAlertViewKey,
  set: setStudentsBenefitAlertView,
  get: getStudentsBenefitAlertView,
}
